import { useMemo } from "react"

import { RoadSearch as RoadSearchComponent, RoadSearchValue } from "../../components/RoadSearch/RoadSearch"
import { useNetworkRoads } from "../../hooks/useNetworkRoads"

type RoadSearchProps = {
    className?: string,
    disableExpend?: boolean,
    mapId?: string,
    module?: string,
    onRoadSearched: (roadSearchValue: RoadSearchValue) => void,
    subNetworks?: string[],
}

export function RoadSearch(props: RoadSearchProps) {
    const {
        className,
        disableExpend,
        module,
        onRoadSearched,
        subNetworks,
    } = props

    const { data: networksRoads } = useNetworkRoads({}, subNetworks, module)
    const options = useMemo(() => {
        return (networksRoads || []).map(road => ({ label: road }))
    }, [networksRoads])

    return (
        <RoadSearchComponent
            className={className}
            disableExpend={disableExpend}
            onValueChanged={onRoadSearched}
            options={options}
        />
    )
}
